module.exports = __webpack_public_path__ + "img/denim-jacket.7f02492e.png";